import { FormField } from '../form.field';
import { IFormField } from '../form.interface';

export class TextField<T = string> extends FormField<T> {
  constructor(args?: IFormField<T>) {
    super({
      ...{ inputType: 'text', inputMethod: 'typing' },
      ...args
    });
  }
}
